import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./container-dropdown-collection.json";
import data from "./container-dropdown-data.json";

export const ContainerDropdownThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
